<template>
    <transition @before-enter="beforeEnter" @enter="enter" @leave="leave" :css="false" appear>
        <section :class="this.name">
            <div id="ranking-bg" class="player"></div>
            <div class="bg"></div>
            <div class="content">
                <div class="cont">
                    <h2>랭킹 시스템</h2>
                    <p>당신의 자존감을 한층 UP! - 랭커 전용 효과</p>
                    <p>- 주위 캐릭터 대상 소셜 액션 자동 발동 -</p>
                    <p>레벨 랭킹 1위 캐릭터가 등장하면 주위의 캐릭터들은 그에게 정중한 인사를 건네며 존경심을 표현한다 (소셜 액션 : 격식인사). 랭킹은 6:30 을 기준으로 1일 단위로 선정된다. </p>
                </div>
                <div id="ranking-video-1" class="player" style="width:890px;height:500px;position:absolute;top:455px;left:50%;margin-left:-445px;  z-index:6;"></div>
            </div>
        </section>
    </transition>
</template>
<script>
    import BasePage from "./mixins/basePage.js";
    import {rePostionContents, reSizeBackground} from '@/utils/cavasResize';
    import canvasObjPosition from '@/utils/canvasObjPosition';
    import YoutubePlayer from "promokit-youtubeplayer";

    export default {
        name: "ranking",
        mixins: [BasePage],
        data() {
            return {
                name: "ranking",
                contentData: [
                    {type: "bg", source: this.$staticUrl + "img/bg_7.jpg", objName: "bg"}
                ]
            };
        },
        methods: {
            canvasSet() {
                this.bgPlayer = new nc.promokit.Player({
                    selector: '#ranking-bg',
                    videoId: 'https://vod.plaync.com/lineage2/old/190220_jinkamael/bg_7.mp4',
                    mute: true,
                    controls: false,
                    coverClick: false,
                    loop: true,
                    autoPlay:true
                });
                this.bgPlayer.pause();
                TweenMax.set(this.$el.querySelector('#ranking-bg'), {autoAlpha:0});

                this.baseCavasSet(this.contentData);


                this.cvObj.txtTitleCon = new PIXI.Container();
                this.cvObj.con.addChild(this.cvObj.txtTitleCon);
                this.cvObj.txtTitle = new PIXI.Sprite.fromImage(this.$staticUrl+'img/txt_7_tit.png');
                canvasObjPosition(this.cvObj.txtTitle, this.cvObj.txtTitleCon, this.contentSize.w/2, 210);

                this.cvObj.txt1Con = new PIXI.Container();
                this.cvObj.con.addChild(this.cvObj.txt1Con);
                this.cvObj.txt1 = new PIXI.Sprite.fromImage(this.$staticUrl+'img/txt_7_txt_1.png');
                canvasObjPosition(this.cvObj.txt1, this.cvObj.txt1Con, this.contentSize.w/2, 298);

                this.cvObj.txt2Con = new PIXI.Container();
                this.cvObj.con.addChild(this.cvObj.txt2Con);
                this.cvObj.txt2 = new PIXI.Sprite.fromImage(this.$staticUrl+'img/txt_7_txt_2.png');
                canvasObjPosition(this.cvObj.txt2, this.cvObj.txt2Con, this.contentSize.w/2, 370);

                this.cvObj.txt3Con = new PIXI.Container();
                this.cvObj.con.addChild(this.cvObj.txt3Con);
                this.cvObj.txt3 = new PIXI.Sprite.fromImage(this.$staticUrl+'img/txt_7_txt_3.png');
                canvasObjPosition(this.cvObj.txt3, this.cvObj.txt3Con, this.contentSize.w/2, 397);
            },
            enter(el, done) {
                this.baseEnter();
                this.canvasSet();
                this.baseEnterMotion(el, done, this.contentData);

                this.enterMotion
                    .fromTo(this.cvObj.txtTitleCon, 1.3, {pixi: { brightness: 3}}, { pixi: { brightness: 1},ease:Power0.easeNone}, 'bgMotionEnd-=0.5')
                    .fromTo(this.cvObj.txtTitle, 1, {pixi: { alpha: 0}}, { pixi: { alpha: 1},ease:Power0.easeNone}, 'bgMotionEnd-=0.5')
                    .fromTo(this.cvObj.txt1, 0.7, {pixi: { alpha: 0, scale:1.2}}, {pixi:{scale:1, alpha:1}, ease:Expo.easeOut}, 'bgMotionEnd+=0.5')
                    .fromTo(this.cvObj.txt2, 0.7,{pixi: { alpha: 0, scale:0.1}},  {pixi:{scale:1, alpha:1}, ease:Expo.easeOut}, 'bgMotionEnd+=0.9')
                    .fromTo(this.cvObj.txt2Con, 0.7,{pixi: { blurX: 50}},  {pixi:{blurX:0}}, 'bgMotionEnd+=0.9')
                    .fromTo(this.cvObj.txt3, 0.7,{pixi: { alpha: 0, scale:0.1}},  {pixi:{scale:1, alpha:1}, ease:Expo.easeOut}, 'bgMotionEnd+=1.3')
                    .fromTo(this.cvObj.txt3Con, 0.7,{pixi: { blurX: 50}},  {pixi:{blurX:0}}, 'bgMotionEnd+=1.3')
                    .fromTo(this.$el.querySelector("#ranking-video-1"), 0.7,{y:50, autoAlpha:0},  {y:0, autoAlpha:1, ease:Power2.easeOut}, 'bgMotionEnd+=1.5')
                    .call(()=>{
                        this.bgPlayer.seek(1);
                        this.bgPlayer.play();
                        TweenMax.set(this.$el.querySelector('#ranking-bg'), {autoAlpha:1})
                    }, null, null, 'bgMotionEnd+=0')
                    .to(this.cvObj.bg, 2, {pixi: { alpha: 0}, delay:0.2 }, 'bgMotionEnd+=0');
                this.enterMotion.play();
            },
            leave(el, done) {
                if (this.enterMotion) this.enterMotion.pause();
                this.baseLeaveMotion(el, done);
            },
            resize(){
                this.documentSetSize.width =  document.querySelector('.container').clientWidth;
                this.documentSetSize.height = document.querySelector('.container').clientHeight;
                if(!this.canvas)return;
                reSizeBackground(this.cvObj.bg, this.documentSetSize.width, this.documentSetSize.height);
                rePostionContents(this.cvObj.con, this.documentSetSize.width, this.documentSetSize.height, this.contentSize.w, this.contentSize.h, true);


                this.canvas.renderer.resize(this.documentSetSize.width, this.documentSetSize.height);

            }
        },
        mounted() {
            let videoRanking = new nc.promokit.Player({
                selector: "#ranking-video-1",
                videoId: "https://vod.plaync.com/lineage2/old/190220_jinkamael/rank.mp4",
                mute: true,
                    controls: false,
                    coverClick: false,
                    loop: true,
                    autoPlay:false
            });
            TweenMax.delayedCall(2.5, ()=>{videoRanking.play();})
            // this.bgPlayer = new nc.promokit.Player({
            //     selector: '#home-bg',
            //     videoId: 'https://vod.plaync.com/lineage2/old/190220_jinkamael/Jinkamael_1.mp4',
            //     mute: true,
            //     controls: false,
            //     coverClick: false,
            //     loop: true,
            //     autoPlay:true
            // });
        }
    };
</script>

